export default __webpack_public_path__ + "static/media/landbrug-og-fødevarer.8d579908.svg";